import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {BrickSnake2000} from "../BrickSnake2000";
import {gsap} from "gsap";
import {BrickSnake2000DoubleOrNothingWinPresentation} from "./BrickSnake2000DoubleOrNothingWinPresentation";
import {BrickSnake2000Sound} from "../sound/BrickSnake2000Sound";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class BrickSnake2000DoubleOrNothingIdlePresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        BrickSnake2000DoubleOrNothingWinPresentation.wasTotalWin = BrickSnake2000.model.data.mode != GameMode.NORMAL;
        if (!BrickSnake2000.apiPlugin.isReplay) {
            tl.add(BrickSnake2000.transitionScreen.enableDoubleOrNothing());
        } else {
            const selectedOption = parseInt(BrickSnake2000.model.data.nextPlayerInteraction.selectedIndex, 10);
            tl.add(BrickSnake2000.transitionScreen.replayDoubleOrNothing(selectedOption));
        }
        tl.add(() => flowStateController.finish());
    }
}